import type { PaymentRailsTranslations } from "../interfaces/paymentRails";

export const paymentRailsTranslations: PaymentRailsTranslations = {
  // Page
  page_title: "Rieles de pago",
  page_subtitle: "Enciende o apaga cada riel, global o por organización, sin despliegues",
  refresh_button: "Actualizar",
  refresh_aria: "Actualizar el estado de los rieles",
  why_banner:
    "Apagar un riel solo bloquea operaciones nuevas: los payins y payouts en vuelo siguen liquidándose con normalidad.",

  // Scope selector
  scope_label: "Alcance",
  scope_placeholder: "Buscar por nombre, correo o ID…",
  scope_loading: "Cargando organizaciones…",
  scope_empty: "No se encontraron organizaciones.",
  scope_searching: "Buscando organizaciones…",
  scope_search_error: "No pudimos completar la búsqueda; se muestran las organizaciones ya cargadas.",
  scope_global_option: "Global (todas las organizaciones)",
  scope_global_label: "Global",
  scope_global_hint: "Alcance global: el interruptor que hereda cualquier organización sin override propio.",
  scope_org_hint:
    "Los cambios aquí crean un override para esta organización, que gana sobre el interruptor global.",
  scope_catalog_error:
    "No pudimos cargar el catálogo de organizaciones; los overrides pueden mostrar IDs en lugar de nombres.",
  scope_catalog_truncated:
    "Hay más organizaciones de las listadas; escribe para buscarlas todas. Algunos overrides pueden mostrar el ID.",

  // KPI strip
  kpi_all: "Riel × dirección",
  kpi_disabled: "Apagados",
  kpi_overrides: "Con overrides",
  kpi_own_overrides: "Con override propio",

  // Table / cards
  section_payins: "Cobros (payins)",
  section_payouts: "Pagos (payouts)",
  th_rail: "Riel",
  th_country: "País",
  th_status: "Estado",
  th_source: "Origen",
  th_overrides: "Overrides",
  direction_payin: "Cobros",
  direction_payout: "Pagos",
  country_ar: "Argentina",
  country_br: "Brasil",
  country_co: "Colombia",
  country_mx: "México",
  status_enabled: "Activo",
  status_disabled: "Apagado",
  source_default: "Activo por defecto",
  source_global_setting: "Ajuste global",
  source_global: "Hereda del global",
  source_org_override: "Override de la organización",
  overrides_count: "{{count}} overrides",
  overrides_count_one: "1 override",
  overrides_count_other: "{{count}} overrides",
  overrides_popover_hint: "Toca una organización para abrir su vista y gestionar su override.",
  action_clear_override: "Quitar override",
  empty_title: "Sin rieles que mostrar",
  empty_description: "Ningún riel coincide con el filtro seleccionado.",

  // Disable dialog (encender es directo desde el switch)
  toggle_title_disable: "Apagar {{rail}}",
  toggle_scope_global: "Este cambio aplica a todas las organizaciones.",
  toggle_scope_org: "Este cambio crea un override solo para la organización seleccionada.",
  toggle_consequence_disable:
    "Las operaciones nuevas en este riel se rechazarán desde ahora. Lo que ya está en vuelo no se toca: se liquida con normalidad.",
  toggle_surviving_overrides_title: "Overrides que seguirán operando",
  toggle_surviving_overrides_text:
    "Estas organizaciones tienen un override encendido que gana sobre el apagado global:",
  reason_label: "Motivo",
  reason_placeholder: "Ej.: incidente del riel — indisponibilidad de la red",
  reason_required: "Indica el motivo del apagado.",
  reason_internal_hint:
    "El motivo es de uso interno: solo lo ve el equipo de Coloca. El cliente ve un mensaje genérico de indisponibilidad.",
  toggle_cancel: "Cancelar",
  toggle_confirm_disable: "Apagar riel",

  // Clear override dialog
  clear_title: "Quitar el override",
  clear_description:
    "La organización volverá a seguir el interruptor global (o el estado por defecto) de este riel.",
  clear_both_directions: "Este override cubre ambas direcciones: quitarlo afecta cobros y pagos a la vez.",
  clear_confirm: "Quitar override",
  clear_cancel: "Cancelar",

  // Toasts / errors
  toast_enabled: "{{rail}} encendido.",
  toast_disabled: "{{rail}} apagado. Las operaciones nuevas se rechazarán.",
  toast_override_cleared: "Override de {{rail}} eliminado.",
  error_load: "No pudimos cargar el estado de los rieles.",
  error_load_detail: "Revisa tu conexión e inténtalo de nuevo.",
  error_retry: "Reintentar",
  error_save: "No pudimos guardar el cambio.",
  error_no_write_permission: "Tu usuario no tiene permiso de escritura sobre pagos.",
};
